var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 41,
    viewBox: "0 0 20 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_975_1126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1903 15.7059H12.5891L4.76172 4.27734H8.36294L16.1903 15.7059ZM13.0182 14.7368H14.4521L7.93384 5.24649H6.49995L13.0182 14.7368Z",
    fill: "#140E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81391 15.7065L9.52362 10.7362L9.03847 9.99219L4.76172 15.7065H5.81391Z",
    fill: "#140E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 8.35799L10.9727 9.03925L15.2385 4.27734H14.142L10.4766 8.35799Z",
    fill: "#140E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 41C15.5228 41 20 36.5228 20 31C20 25.4772 15.5228 21 10 21C4.47715 21 0 25.4772 0 31C0 36.5228 4.47715 41 10 41Z",
    fill: "#F73759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1903 36.7059H12.5891L4.76172 25.2773H8.36294L16.1903 36.7059ZM13.0182 35.7368H14.4521L7.93384 26.2465H6.49995L13.0182 35.7368Z",
    fill: "#140E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81391 36.7065L9.52362 31.7362L9.03847 30.9922L4.76172 36.7065H5.81391Z",
    fill: "#140E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 29.358L10.9727 30.0392L15.2385 25.2773H14.142L10.4766 29.358Z",
    fill: "#140E1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_975_1126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0d5f9336d3f4310e58cb8199e79c1799.svg";
export { ForwardRef as ReactComponent };